function randomSample(array, n) {
    // random sample of length n from array. If n > array length, keep repeating array until there
    // are enough items.
    const sample = [];
    let shuffledArray = shuffleArray(array);
    let arrayLength = shuffledArray.length
    while (n > arrayLength) {
        shuffledArray = shuffledArray.concat(shuffleArray(array))
        arrayLength = shuffledArray.length
    }
    for (let i = 0; i < n; i++) {
        sample.push(shuffledArray.pop());
    }
    return sample;
}
function shuffleArray(array, freezeUpTo = 0) {
    // freezeUpTo allows you to exclude the first x elements from the shuffle
    let shuffleArray = array.slice(freezeUpTo);
    // From: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
    for (let i = shuffleArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffleArray[i], shuffleArray[j]] = [shuffleArray[j], shuffleArray[i]]
    }
    return array.slice(0, freezeUpTo).concat(shuffleArray)
}

const arrayRange = (start=0, stop=10, step=1) =>
    Array.from(
        { length: (stop - start) / step + 1 },
        (value, index) => start + index * step
    );


function randomizeMSEmoTasks(emotion_q, ms_instruction_q, ms_qs) {
    const randomizedMentalStateTasks = randomSample(ms_qs, ms_qs.length);
    // Randomly decide whether to start with postInductEmotion or postInductMSInstructions
    if (Math.random() < 0.5) {
        return [emotion_q, ms_instruction_q, ...randomizedMentalStateTasks];
    } else {
        return [ms_instruction_q, ...randomizedMentalStateTasks, emotion_q];
    }
}

export {randomSample, shuffleArray, arrayRange, randomizeMSEmoTasks}